import styles from './uploadSaleReceiptForm.module.css'
import { Form, FormField, ModalId, useUIActions, FieldType, FileField, FileType, Validatable, Spinner } from "../../../../../features/ui"
import { useState } from "react"
import { toList } from "../../../../../utils/listUtils"
import { useActions } from "./actions"
import { TableName } from '../../../../../tables'
import { SaleOperation, SalePaymentItem } from '../../../state/types'
import { operationHelpers } from '../../../../operations'
import { usePaymentTypeLoaders } from '../../../../administration'
import { useDataTypesHooks } from '../../../../../features/data-types'
import { saleOperationHelpers } from '../../../hooks/saleOperationHooks'

type Props = {
    table: TableName
    operation?: SaleOperation
    paymentItem?: SalePaymentItem
}

export const UploadSaleReceiptForm = (props: Props) => {
    const { table, operation, paymentItem } = props
    
    const [receiptFile, setReceiptFile] = useState<File>()
    const [receiptValidation, setReceiptValidation] = useState<string>()
    
    const { paymentReceiptFileName } = saleOperationHelpers
    const { describeNoun, describeCode } = operationHelpers
    const { formatPrice } = useDataTypesHooks()
    
    const paymentTypeLoaders = usePaymentTypeLoaders()

    const { submitReceipt } = useActions()
    const { closeModal } = useUIActions()

    if (!operation || !paymentItem) return <Spinner />

    const onChangeFile = (value?: File) => {
        setReceiptValidation(undefined)
        setReceiptFile(value)
    }

    const fields: FormField[] = [
        {
            name: 'operation',
            type: FieldType.TEXT,
            label: describeNoun(table),
            render: () => <>{describeCode(operation)}</>
        },
        {
            name: 'paymentItem',
            type: FieldType.TEXT,
            label: 'Medio de Pago',
            render: () => {
                const { findPaymentType } = paymentTypeLoaders()
                const paymentType = findPaymentType(paymentItem.paymentTypeId)
                return <>{paymentType?.name || 'Sin medio de pago'} ({formatPrice(paymentItem.amount)})</>
            }
        },
        {
            name: 'receiptFile',
            type: FieldType.FILE,
            label: 'Comprobante',
            hint: 'Formato: PDF, JPG, PNG',
            render: () => (
                <Validatable validations={toList(receiptValidation)} left className={styles.receiptValidation}>
                    <FileField
                        id="receiptUrl"
                        fileName={paymentReceiptFileName()}
                        fileTypes={[FileType.PDF, FileType.JPEG, FileType.PNG]}
                        onChange={onChangeFile}
                    />
                </Validatable>
            )
        }
    ]
    
    const validate = (): boolean => {
        if (!receiptFile) {
            setReceiptValidation('Debe subir el comprobante')
            return false
        }
    
        return true
    }

    const onSubmit = () => {
        if (validate()) {
            submitReceipt(table, operation.id, paymentItem, receiptFile!)
        }
    }

    const handleCancel = () => closeModal(ModalId.UPLOAD_SALE_RECEIPT)

    return (
        <Form
            formId="upload-sale-receipt-form"
            fields={fields}
            createMode={false}
            updateLabel="Confirmar"
            onSubmit={onSubmit}
            onCancel={handleCancel}
        />
    )
}
